module.exports = __webpack_public_path__ + "../assets/img/8dd45fec219c97f63300aebeff28799d.svg";